import * as React from 'react';
import { Grid, Paper } from '@mui/material';
import DownloadItem from './DownloadItem';
import './DownloadPaperStyles.css';

export interface IDownloadPaperProps {

}

const DownloadPaper = (props: IDownloadPaperProps) => {
    return (
        <Paper className="download-paper-container" elevation={24}>
            <Grid className="download-paper-grid-container" container direction="column">
                <Grid className="download-paper-grid-item" item>
                    <DownloadItem label="Source Code Optimierung" url="./downloads/gamepad-optimize-plot.zip" />
                </Grid>
                <Grid className="download-paper-grid-item" item>
                    <DownloadItem label="Source Code Steuerung" url="./downloads/gamepad-control.zip" />
                </Grid>
                <Grid className="download-paper-grid-item" item>
                    <DownloadItem label="Videopräsentation" url="./downloads/error404hci_presentation.mp4" />
                </Grid>
                <Grid className="download-paper-grid-item" item>
                    <DownloadItem label="Präsentationsposter" url="./downloads/poster.svg" />
                </Grid>
            </Grid>
        </Paper>
    )
}

export default DownloadPaper;